import React from "react";
import { missao, visao, valores } from "./data/principles";

const primeiraFrase = (texto) => texto.split(". ")[0] + ".";

const Principles = () => {
  return (
    <div className="scroll-mt-24 xl:scroll-mt-32" id="missao-visao-valores">
      <div className="bg-white">
      <div className="text-black w-3/4 mx-auto xl:py-32 py-16">
        <p className="text-sm font-semibold uppercase tracking-widest text-pattern-dark mb-4 xl:text-center">No que acreditamos</p>
        <h2 className="text-3xl xl:text-5xl font-semibold xl:text-center mb-12 xl:mb-20">
          Missão, visão e valores
        </h2>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-10 xl:gap-16 mb-16">
          <div>
            <h3 className="text-2xl xl:text-3xl font-semibold mb-4">Missão</h3>
            <p className="text-lg leading-relaxed text-gray-700">{missao}</p>
          </div>
          <div>
            <h3 className="text-2xl xl:text-3xl font-semibold mb-4">Visão</h3>
            <p className="text-lg leading-relaxed text-gray-700">{visao}</p>
          </div>
        </div>

        <h3 className="text-2xl xl:text-3xl font-semibold mb-8">Valores</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-8">
          {valores.map((valor) => (
            <li key={valor.titulo}>
              <h4 className="text-lg font-semibold mb-2">{valor.titulo}</h4>
              <p className="text-base leading-relaxed text-gray-700">{primeiraFrase(valor.texto)}</p>
            </li>
          ))}
        </ul>
      </div>
      </div>
    </div>
  );
};

export default Principles;
